<template>
    <b-col sm="12" md="12">
        <b-row>
          <b-col cols=8>
            <b-tabs v-model="currentTab">
              <b-tab v-for="group in fieldGroups" :key="group" :href="groupName(group)">
                    <template slot="title">
                        <span v-if="group == ''">{{ $t('default') }}</span>
                        <span v-else>{{ groupName(group) }}</span>
                    </template>
                    
                      <draggable tag="div" :class="{row:true, fieldDroppable: draggingField}" v-model="fields" group="fields">
                        <b-col cols="12" :key="idx" v-for="(field, idx) in fields">
                          <b-form-group
                            :label="$translateLabel(field.label, field.name)"
                            v-if="field.group == group"
                          >
                            <b-badge class="fieldBadge p-2" @click="editModal(field)" variant="dark">
                              <b-row>
                                <b-col cols="1"> <b-icon :icon="getFieldDefinition(field).icon" /></b-col>
                                <b-col cols="10" align-self="center">  {{ $t(getFieldDefinition(field).title) }} </b-col>
                              </b-row>
                            </b-badge>
                          </b-form-group>
                        </b-col>
                      </draggable>
                </b-tab>
                
            </b-tabs>
          </b-col>
          <b-col cols="4">
            <DraggableFields :group="{ name: 'fields', pull: 'clone', put: false }" :mutateClone="onClone" @dragStart="draggingField = true" @dragEnd="draggingField = false"/>
          </b-col>
        </b-row>


        <b-sidebar right v-model="editFieldModal.show">
          <FieldEdit v-model="editFieldModal.field" v-if="editFieldModal.field" :fields="fields" :component="component"></FieldEdit>

          <template #footer>
              <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
                  <b-button variant="success" @click="editField" size="sm">{{$t('save')}}</b-button>
                  <b-button variant="danger" @click="remove(editFieldModal.field)" class="ml-2" size="sm">{{$t('delete')}}</b-button>
              </div>
          </template>
        </b-sidebar>
      </b-col>
</template>

<script>

import fieldDefs from "@/components/identityFields/defsv2"
import fieldObj from "@/components/identityFields/field"
import IdentityFields from '@/components/identityFields/IdentityFields'
import Mutators from "./Mutators"
import Relationships from "./Relationships"
import Template from "./Template"
import Constraints from "./Constraints"
import Context from "./Context"
import { Switch as cSwitch } from '@coreui/vue'
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import _ from "lodash"
import Helptip from '../../elements/Helptip.vue'
import VSelect from 'vue-select'
import draggable from 'vuedraggable'
import Vue from 'vue'

// css
import Texti18n from "../../form/Texti18n.vue"
import DraggableFields from './DraggableFields.vue'
import FieldEdit from "./FieldEdit.vue"

export default {
  components: {
    MutatorsEditor: Mutators,
    RelationshipsEditor: Relationships,
    ConstraintsEditor: Constraints,
    ContextEditor: Context,
    cSwitch,
    InputField: Input,
    SelectField: Select,
    Helptip,
    VSelect,
    Texti18n,
    Template,
    IdentityFields,
    draggable,
    DraggableFields,
    FieldEdit
},
  props: {
      value: {
        type: Array,
        default: function() {
          return []
        }
      },
      config: {
        type: Object,
        default: function() {
          return {
            fieldDefs: fieldDefs,
            hideGroup: false,
            hideProtected: false,
            hideVisible: false,
            fieldSize: 4,
            custom: false,
            dependencyProtected: false,
            version: 0,
          }
        }
      },

      component: {
        Type: Object
      }
  },
  data: function() {
    return {
      autogenerateKey: true,
      errors: [],
      newFieldModal: {
        show: false,
        field: _.cloneDeep(fieldObj)
      },

      editFieldModal: {
        show: false,
        field: _.cloneDeep(fieldObj)
      },

      currentTab: 0,
      draggingField: false
    }
  },
  watch: {
    "newFieldModal.field.name": function(val) {
      if (this.autogenerateKey) {
         this.$set(this.newFieldModal.field, 'key',  _.replace(_.toLower(val), /\s/g, "_"))
      }

      this.newFieldModal.field.name = _.startCase(_.toLower(val))
    },

    "editFieldModal.field.name": function(val) {
      this.editFieldModal.field.name = _.startCase(_.toLower(val))
    },

    "newFieldModal.field.key": function(val) {
      if (!this.autogenerateKey) {
        this.$set(this.newFieldModal.field, 'key',  _.trim(_.replace(_.replace(_.toLower(val), " ", "_"), "__", "_"), "_"))
      }
    },

    autogenerateKey: function(val) {
      if (val) {
        this.newFieldModal.field.key = _.replace(_.toLower(this.newFieldModal.field.name), /\s/g, "_")
      }
    }
  },
  computed: {
    availablePermissions() {
      let perms = ["public-app", "platform-app", "public-api"]

      let publicApps = this.$store.getters.getPublicApps || []
      publicApps.forEach(p => {
        perms.push(`public-app::${p.name}`)
      })

      let platformApps = this.$store.getters.getApps || []
      platformApps.forEach(p => {
        perms.push(`platform-app::${p.name}`)
      })

      return perms
    },

    fields: {
      set(val) {
        this.$emit('input', val.filter(f => {
          return this.getFieldDefinition(f)
        }))
      },

      get() {
        const v = this.value || []

        return v.filter(f => {
          return this.getFieldDefinition(f)
        }) || []
      }
    },

    fieldGroups() {
      try {
        let groups = {
          '': true
        }
        
        this.fields.forEach(f => {
            const group = f.group || ''
            
            groups[group] = true
        })

        return Object.keys(groups);
      } catch(err) {
        this.$debugLog(err)

        return ['']
      }
    },

    fieldDefs() {
      if (this.config !== null) {
        if (this.config.fieldDefs) {
          return this.config.fieldDefs
        }
      }

      return fieldDefs
    },

    roles() {
      return this.$store.getters.getRoles.map(r => {
        return {
          label: r.name,
          value: r.uuid
        }
      })
    },

    modules() {
      return this.fieldDefs.modules.map(m => {
        return m.key
      })
    },

    types() {
      const module = this.fieldDefs.modules.find(m => {
        return m.key == this.editFieldModal.field.module
      })

      const { fields = [] } = module || {}

      return fields.map(f => {
        return f.key
      })
    }
  },
  methods: {
    editModal(field) {
      field = _.cloneDeep(field)
      let fieldO = _.cloneDeep(fieldObj) 

      Vue.set(this.editFieldModal, "field", {
        ...fieldO,
        ...field
      })

      this.editFieldModal.show = true
      this.editFieldModal.fieldOld = field
    },

    groupName(group) {
      return _.capitalize(group)
    },

    insertField(event) {
      console.log("insertField", event)
    },

    fieldAdded(event, a, b) {
      console.log("reorderField", event, a, b);
    },

    fieldCopy(event) {
      console.log("fieldCopy", event)
    },

    onClone(original) {
      original.name = `Field${this.fields.length+1}`
      original.key = `field${this.fields.length+1}`
      original.group = this.fieldGroups[this.currentTab]

      return original
    },

    getFieldDefinition(field) {
      let def = this.fieldDefs.modules.find(m => {
        return m.key == field.module
      })

      return def.fields.find(f => {
        return f.key == field.type
      })
    },

     cloneField(field) {
       // reset keys so new name and key can be set
      let cField =  _.cloneDeep(field)
      cField.name = ""
      cField.key = ""

      this.newFieldModal.field = cField
      this.newFieldModal.show = true
      this.newFieldModal.fieldOld = cField
    },

    editField(modal) {
      let field = this.editFieldModal.field
      let oldField = this.editFieldModal.fieldOld

      let fields = this.fields.map(el => {
        if (el.key == oldField.key) {
          return field
        } else {
          return el
        }
      });

      if (this.checkForErrors()) {
        this.$bvModal.msgBoxOk(this.$t('fieldsNotValid'))

        modal.preventDefault();

        return false
      }

      this.editFieldModal.show = false

      this.fields = fields
    },

    addNewField(modal) {
      if (this.checkForErrors()) {
        this.$bvModal.msgBoxOk(this.$t('fieldsNotValid'))

        modal.preventDefault();

        return false
      }

      if (this.validateFields()) {
        this.$bvModal.msgBoxOk(this.$t('fieldsAlreadyExist'))

        modal.preventDefault();

        return false
      }

      //console.log(fieldObj)
      this.fields.push(this.newFieldModal.field)
      this.newFieldModal.field = _.cloneDeep(fieldObj)

      this.$emit('input', this.fields)

      return true
    },

    addNewFieldAndClose(modal) {
      if (this.addNewField(modal)) {
        this.newFieldModal.show = false
      }
    },

    hideEditField(modal) {
      if (modal.trigger != 'cancel' && modal.trigger != 'ok') {

        if (JSON.stringify(this.editFieldModal.fieldOld) != JSON.stringify(this.editFieldModal.field)) {
          modal.preventDefault()

          this.$bvModal.msgBoxOk(this.$t('unsavedChanges'));
        }
      }

      if (modal.trigger == 'cancel') {
        this.editFieldModal.field = this.editFieldModal.fieldOld
      }
    },

    remove(field) {
      this.$bvModal.msgBoxConfirm('Are you sure?').then((value) => {
        if (value) {
          let fields = this.fields.filter(f => {
            return f.key != field.key
          })

          this.editFieldModal.show = false
          this.$emit('input', fields)
        }
      })
    },

    newFieldModalShow() {
      this.newFieldModal.field = _.cloneDeep(fieldObj)
      this.newFieldModal.show = true
    },

    fieldError(error) {
      let found = this.errors.find((i, e) => {
          return i.field == error.field
      })

      if (found === undefined) {
          this.errors.push(error)
      } else {
          this.errors.map(e => {
              if (found.field == e.field)
                  e.error = error.error
          })
      }
    },

    checkForErrors() {
      // for some fcking weird reason there is no error when Name is set to empty string, it doesn't show that fields is required
      // even though Key field is same and functions properly, fck this stupid shit, this is workaround i dont have time in my life to fck with this nonsense
      if (this.newFieldModal.field.name == "" && this.editFieldModal.field.name == "") {
        return true
      }

      if (this.newFieldModal.field.type == "" && this.editFieldModal.field.type == "") {
        return true
      }

      return this.errors.find((i, e) => {
        return i.error
      })
    },

    validateFields() {
      return this.fields.find(f => {
        return this.newFieldModal.field.key == f.key || this.newFieldModal.field.name == f.name
      })
    },

    helpfulTip(field) {
      if (field.module == "table") {
        if (field.type == "custom") {
           return {id: "identityField.table.custom", type: "icon", title: "Did you know?", size: "lg"}
        }
      }
    },

    canDisplayRelationships(field) {
      let mod = field.module
      let type = field.type

      switch(mod) {
        case 'select': return type == 'relation';
        case 'table': return type == 'default';
        default: return false
      }
    },

    canDisplayTemplate(field) {
      let mod = field.module
      let type = field.type

      switch(mod) {
        default: return true
      }
    },

    formatFieldPermissions(field) {
      if (field.permissions) {
        return field.permissions
      }

      return '*'
    }
  },

  mounted() {
    this.$store.dispatch('fetchRoles')
  }
}
</script>

<style lang="scss">
.fieldBadge {
  width: 100%;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  .b-icon {
    font-size: 25px;
  }

  .fieldControls {
    text-align: right;

    .b-icon {
      font-size: 15px;
    }

    .bi-trash {
      color: red;
    }
  }
}

.fieldDroppable {
  padding: 10px;
  margin: 10px;
  border: 1px dashed #ccc;
}
</style>